import type {
  GetFuneralHomeCaseNormalized,
  GetFuneralHomeOrderNormalized,
} from '@messenger/types'

import { caseDates } from '@/mocks/dates/caseDates'
import { dashboardDates } from '@/mocks/dates/dashboardDates'

import type { Case, Order, Service } from '@/types/case'

import { convertObjectOfDates } from '@/utils/dates/convertObjectOfDates'
import { isoStringToDate } from '@/utils/dates/isoStringToDate'

type OrderWithCase = Order & {
  case?: Case
}

export const sanitizeDashboardDates = (
  originalCells:
    | Case[]
    | OrderWithCase[]
    | GetFuneralHomeCaseNormalized[]
    | GetFuneralHomeOrderNormalized['orders'],
) => {
  const cells = [...originalCells]

  cells.forEach(
    (
      cell:
        | Case
        | OrderWithCase
        | GetFuneralHomeCaseNormalized
        | GetFuneralHomeOrderNormalized['orders'][number],
    ) => {
      convertObjectOfDates(dashboardDates.table, cell, isoStringToDate)

      if ('case' in cell) {
        // @ts-expect-error - we know it's a case
        cell.case?.services?.forEach((service: Service) =>
          convertObjectOfDates(caseDates.service, service, isoStringToDate),
        )
      } else {
        ;(cell as Case).services?.forEach((service: Service) =>
          convertObjectOfDates(caseDates.service, service, isoStringToDate),
        )
      }
    },
  )

  return cells
}

export default sanitizeDashboardDates
